/**
 * Hero (background video) functionality
 * @class
 */
export default class Hero {
    /**
     * @constructor
     * @param {HTMLElement} element The Hero root element
     */
    constructor(element) {
        var _a, _b, _c, _d;
        this.element = element;
        this.backgroundVideo = element.querySelector('[data-component="hero-video"]');
        this.playBtn = element.querySelector('[data-component="hero-video-play-button"]');
        this.pauseBtn = element.querySelector('[data-component="hero-video-pause-button"]');
        this.restartBtn = element.querySelector('[data-component="hero-video-restart-button"]');
        const swapPlayAndPauseButtons = () => {
            var _a, _b, _c, _d;
            (_a = this.playBtn) === null || _a === void 0 ? void 0 : _a.classList.toggle('hidden');
            (_b = this.playBtn) === null || _b === void 0 ? void 0 : _b.classList.toggle('visible');
            (_c = this.pauseBtn) === null || _c === void 0 ? void 0 : _c.classList.toggle('visible');
            (_d = this.pauseBtn) === null || _d === void 0 ? void 0 : _d.classList.toggle('hidden');
        };
        const swapPauseAndRestartButtons = () => {
            var _a, _b, _c, _d;
            (_a = this.pauseBtn) === null || _a === void 0 ? void 0 : _a.classList.toggle('visible');
            (_b = this.pauseBtn) === null || _b === void 0 ? void 0 : _b.classList.toggle('hidden');
            (_c = this.restartBtn) === null || _c === void 0 ? void 0 : _c.classList.toggle('hidden');
            (_d = this.restartBtn) === null || _d === void 0 ? void 0 : _d.classList.toggle('visible');
        };
        const handleUsersWhoPreferReducedMotion = () => {
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            if (prefersReducedMotion.matches && this.backgroundVideo) {
                //console.log('User prefers reduced motion.');
                this.backgroundVideo.removeAttribute('autoplay');
                this.backgroundVideo.pause();
                swapPlayAndPauseButtons();
            }
        };
        const playVideo = () => {
            if (this.backgroundVideo) {
                this.backgroundVideo.play();
                swapPlayAndPauseButtons();
            }
        };
        const pauseVideo = () => {
            if (this.backgroundVideo) {
                this.backgroundVideo.pause();
                swapPlayAndPauseButtons();
            }
        };
        const restartVideo = () => {
            if (this.backgroundVideo) {
                this.backgroundVideo.currentTime = 0;
                this.backgroundVideo.play();
                swapPauseAndRestartButtons();
            }
        };
        handleUsersWhoPreferReducedMotion();
        (_a = this.playBtn) === null || _a === void 0 ? void 0 : _a.addEventListener("click", playVideo);
        (_b = this.pauseBtn) === null || _b === void 0 ? void 0 : _b.addEventListener("click", pauseVideo);
        (_c = this.restartBtn) === null || _c === void 0 ? void 0 : _c.addEventListener("click", restartVideo);
        (_d = this.backgroundVideo) === null || _d === void 0 ? void 0 : _d.addEventListener("ended", swapPauseAndRestartButtons);
        //console.log('Welcome to Hero', this)
    }
    /**
     * Creates new instances of IHeroUtils for each `data-component="Hero"` element,
     * and adds the necessary event listeners to support playing and pausing of the background video.
     */
    static init() {
        const heroes = [...document.querySelectorAll('[data-component="Hero"]')];
        heroes.forEach(hero => {
            const heroUtil = new Hero(hero);
        });
    }
}
